import { useLocale } from '@dreamstack/i18n'
import { RouterOutputs } from '@dreamstack/trpc/client'
import type { FunctionComponent } from 'react'
import { BodyText, HeadingH2 } from '../layout/Texts'
import { ContinueReadingLink } from '../news/ContinueReadingLink'
import { getLexiconPath } from './getLexiconPath'

export const LexiconPreview: FunctionComponent<
  React.PropsWithChildren<{
    lexiconArticle:
      | RouterOutputs['cms']['getLexiconArticle']['article']
      | RouterOutputs['cms']['getLexiconArticlePreviews']['items'][number]
  }>
> = ({ lexiconArticle }) => {
  const locale = useLocale()
  if (!lexiconArticle) return null
  const { slug, lexiconLetter, title, previewText } = lexiconArticle
  if (!slug || !lexiconLetter) return null
  const href = getLexiconPath({ locale, slug, lexiconLetter })

  // Using a simple wrapper with a utility class for mark background
  // Tailwind v4 supports arbitrary selectors via prose or we can add a scoped style.
  // Here we inline a style tag to keep concerns local without twin.
  const MarkWrapper = ({ children }: { children: React.ReactNode }) => (
    <div className="lexicon-preview-wrapper">
      <style>{`.lexicon-preview-wrapper mark { @apply bg-accentroAquaVeryLight-full; }`}</style>
      {children}
    </div>
  )
  return (
    // eslint-disable-next-line react-hooks/static-components
    <MarkWrapper>
      {typeof title === 'string' ? (
        <HeadingH2
          className="hyphens-auto"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      ) : (
        <HeadingH2 className="hyphens-auto">{title}</HeadingH2>
      )}
      <BodyText className="mt-px-32">{previewText}</BodyText>
      <ContinueReadingLink href={href} />
    </MarkWrapper>
  )
}
